(function($) {
  'use strict';
  
  $('.goreview[data-toggle="tooltip"]').tooltipster({
    animation: 'fade',
    delay: 100,
    theme: 'tooltipster-borderless'
  }); 
  
  function scrollToHash() {

    // Add smooth scrolling to all links
    $("a.goreview").on('click', function(event) {

      // Make sure this.hash has a value before overriding default behavior
      if (this.hash !== "") {
        // Prevent default anchor click behavior
        event.preventDefault();

        // Store hash
        var hash = this.hash;

        // Using jQuery's animate() method to add smooth page scroll
        // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
        $('html, body').animate({
          scrollTop: $(hash).offset().top -60
        }, 800, function(){

          // Add hash (#) to URL when done scrolling (default click behavior)
          //window.location.hash = hash;
        });
      } // End if
    });
  }

  
  function scrollBar() {
    Scrollbar.initAll({
      speed: 1,
      overscrollEffect : 'glow',
      overscrollEffectColor : '#CF000F',
      alwaysShowTracks : true
    });
  }

  
  function mainSlider() {
    var $slideshow = $('.home-slider');
    $slideshow.owlCarousel({
      animateOut: 'fadeOut',
      animateIn: 'fadeIn',
      mouseDrag : false,
      items: 1,
      margin: 0,
      stagePadding: 0,
      smartSpeed:450,
      nav : false,
      loop: true,
      lazyContent : true,
      autoplay : true,
      autoplayTimeout : 5000
    });
  }

  function relatedSlider(){
    $('.related-products-items.owl-carousel').owlCarousel({
      loop:true,
      margin: 15,
      nav: true,
      dots: false,
      lazyLoad:true,
      responsiveClass:true,

      responsive:{
        0:{
          items:2,
          margin:5,
          nav:true
        },
        600:{
          items:3,
          margin:10,
          nav:true
        },
        1000:{
          items:5,
          nav:true
        }
      }
    })
  }
  
  function heroVideo(){
    //Video-home
      $('.popup-youtube').magnificPopup({
        disableOn: false,
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        iframe: {
          patterns: {
            youtube: {
              index: 'youtube.com', 
              id: 'v=', 
              src: '//www.youtube.com/embed/%id%?rel=0&showinfo=0&modestbranding=0&autoplay=1'
            }
          }
        }  ,
        fixedContentPos: false
      });
  }
  
  function sticky() {
    $('.site-header').stickUp();
    
    $('.product-single__left-wrapper').stickUp({
      topMargin : '110px',
      keepInWrapper:!0,
      wrapperSelector: ".product-single",
      disableOn : function(){
        if( $(window).width() < 768 )
          return false;
        return true;
      }
    });


    //     $('.product-single__submit').stickUp({
    //       disableOn : function(){
    //         if( $(window).width() > 768 )
    //           return false;
    //         return true;
    //       }
    //     });
  }

  function mailChimp(){
    //Mailchimp on footer
    $('.footer-subscribe__form .subscribe').click(function(){
      var $form = $('.footer-subscribe__form');
      $.ajax({
        type: $form.attr('method'),
        url: $form.attr('action'),
        data: $form.serialize(),
        cache       : false,
        dataType    : 'json',
        contentType: "application/json; charset=utf-8",
        error       : function(err) { alert("Could not connect to the registration server. Please try again later."); },
        success     : function(data) {
          if (data.result != "success") {
            var data = data.msg,
              newData = data.replace('1 -','').replace('0 -','');
            $(".footer-subscribe__form .response-text").show();
            $(".footer-subscribe__form .response-text").removeClass("success");
            $(".footer-subscribe__form .response-text").addClass("error");
            $(".footer-subscribe__form .response-text").html(newData);              
          } 
          else 
          {
            $(".footer-subscribe__form .response-text").show();
            $(".footer-subscribe__form .response-text").removeClass("error");
            $(".footer-subscribe__form .response-text").addClass("success");
            $(".footer-subscribe__form .response-text").html("Please check your email and confirm your subscription.");
          }
        }
      });
    });
    $( ".footer-subscribe__form" ).keypress(function(e) {
      if(e.which == '13') {
        $( ".footer-subscribe__form .subscribe" ).trigger( "click" );
        return false;
      }    
    }); 
    
      
  //Mailchimp on Home section
  $('.home-newsletter__form #subscribe').click(function(){
    var $form = $('.home-newsletter__form');
    $.ajax({
      type: $form.attr('method'),
      url: $form.attr('action'),
      data: $form.serialize(),
      cache       : false,
      dataType    : 'json',
      contentType: "application/json; charset=utf-8",
      error       : function(err) { alert("Could not connect to the registration server. Please try again later."); },
      success     : function(data) {
        if (data.result != "success") {
          var data = data.msg,
              newData = data.replace('1 -','').replace('0 -','');
          $(".home-newsletter__form .response-text").show();
          $(".home-newsletter__form .response-text").removeClass("success");
          $(".home-newsletter__form .response-text").addClass("error");
          $(".home-newsletter__form .response-text").html(newData);              
        } 
        else 
        {
          $(".home-newsletter__form .response-text").show();
          $(".home-newsletter__form .response-text").removeClass("error");
          $(".home-newsletter__form .response-text").addClass("success");
          
          $(".home-newsletter__form .response-text").html("Please check your email and confirm your subscription.");
        }
      }
    });
  });
  $( ".home-newsletter__form" ).keypress(function(e) {
    if(e.which == '13') {
      $( ".home-newsletter__form #subscribe" ).trigger( "click" );
      return false;
    }    
  }); 
    
    
    //Mailchimp on Popup
   $('.newsletter-popup__form .sign_up').click(function(){
    var $form = $('.newsletter-popup__form');
    $.ajax({
      type: $form.attr('method'),
      url: $form.attr('action'),
      data: $form.serialize(),
      cache       : false,
      dataType    : 'json',
      contentType: "application/json; charset=utf-8",
      error       : function(err) { alert("Could not connect to the registration server. Please try again later."); },
      success     : function(data) {
        if (data.result != "success") {
          var data = data.msg,
              newData = data.replace('1 -','').replace('0 -','');
          $(".newsletter-popup__form .response-text").show().removeClass("success").addClass("error").html(newData);  
          setTimeout(function(){ $(".newsletter-popup__form .response-text").hide(); }, 5000);
        } 
        else 
        {
          //$(".mailchimp-form .response-text").show();
          $(".newsletter-popup__form .response-text").removeClass("error");
          $(".newsletter-popup__form .response-text").addClass("success");
          //$(".mailchimp-form .response-text").html("Please check your email and confirm your subscription.");
          $('#newsletter-popup .newsletter').hide();
          $('#newsletter-popup .newsletter-popup-container p').html("<p>Thank you, and welcome to our store. Here is your 10% off code: WELCOME10 You can copy and paste the code for immediate use.</p>");
          //setTimeout(function(){ $(".mailchimp-form .response-text").hide(); }, 5000);

        }
      }
    });
  });
    
  $( ".newsletter-popup__form" ).keypress(function(e) {
    if(e.which == 13) {
      $( ".newsletter-popup__form .sign_up" ).trigger( "click" );
      return false;
    }    
  });
    
}


  $(document).ready(function() {
      scrollToHash();
      sticky();
      mainSlider();
      mailChimp();
      relatedSlider();
      heroVideo();
      scrollBar();
  });

})(jQuery);
